import { render } from "./popupimage.vue?vue&type=template&id=4677eb4c&scoped=true"
import script from "./popupimage.vue?vue&type=script&lang=js"
export * from "./popupimage.vue?vue&type=script&lang=js"

import "./popupimage.vue?vue&type=style&index=0&id=4677eb4c&scoped=true&lang=scss"
import "./popupimage.vue?vue&type=style&index=1&id=4677eb4c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4677eb4c"]])

export default __exports__